import {
  IntIteratordtlvcwxsuu5a as IntIterator,
  LongIterator6nf6jdg4ti4 as LongIterator,
} from '../collections/PrimitiveIterators.mjs';
import { NoSuchElementException679xzhnp5bpj as NoSuchElementException } from '../exceptions.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
import { add2suhfggl4zvkk as add } from '../js/internal/longAsBigInt/longAsBigInt.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var IntProgressionIteratorClass;
function IntProgressionIterator() {
  if (IntProgressionIteratorClass === VOID) {
    class $ extends IntIterator() {
      constructor(first, last, step) {
        super();
        this.step_1 = step;
        this.finalElement_1 = last;
        this.hasNext_1 = this.step_1 > 0 ? first <= last : first >= last;
        this.next_1 = this.hasNext_1 ? first : this.finalElement_1;
      }
      hasNext_bitz1p_k$() {
        return this.hasNext_1;
      }
      nextInt_ujorgc_k$() {
        var value = this.next_1;
        if (value === this.finalElement_1) {
          if (!this.hasNext_1)
            throw NoSuchElementException().new_kotlin_NoSuchElementException_wy3d4q_k$();
          this.hasNext_1 = false;
        } else {
          this.next_1 = this.next_1 + this.step_1 | 0;
        }
        return value;
      }
    }
    initMetadataForClass($, 'IntProgressionIterator');
    IntProgressionIteratorClass = $;
  }
  return IntProgressionIteratorClass;
}
var LongProgressionIteratorClass;
function LongProgressionIterator() {
  if (LongProgressionIteratorClass === VOID) {
    class $ extends LongIterator() {
      constructor(first, last, step) {
        super();
        this.step_1 = step;
        this.finalElement_1 = last;
        this.hasNext_1 = this.step_1 > 0n ? first <= last : first >= last;
        this.next_1 = this.hasNext_1 ? first : this.finalElement_1;
      }
      hasNext_bitz1p_k$() {
        return this.hasNext_1;
      }
      nextLong_njwv0v_k$() {
        var value = this.next_1;
        if (value === this.finalElement_1) {
          if (!this.hasNext_1)
            throw NoSuchElementException().new_kotlin_NoSuchElementException_wy3d4q_k$();
          this.hasNext_1 = false;
        } else {
          this.next_1 = add(this.next_1, this.step_1);
        }
        return value;
      }
    }
    initMetadataForClass($, 'LongProgressionIterator');
    LongProgressionIteratorClass = $;
  }
  return LongProgressionIteratorClass;
}
//region block: exports
export {
  IntProgressionIterator as IntProgressionIterator2ovd1ctrmu51n,
  LongProgressionIterator as LongProgressionIterator2e3slqmdh4zt7,
};
//endregion

//# sourceMappingURL=ProgressionIterators.mjs.map
